import {
  Card,
  Icon,
  GridLegacy,
  Stack,
  Typography,
} from '@sbv-clients/ui-shared';

interface CounterProps {
  title: string;
  counterValue: number;
  onClick?: () => void;
  backgroundColor: string;
}

const Counter = ({
  title,
  counterValue,
  onClick,
  backgroundColor,
}: CounterProps) => {
  return (
    <Card
      elevation={2}
      onClick={onClick}
      sx={{
        p: 3,
        height: '100%',
        cursor: 'pointer',
        borderRadius: 1.5,
        backgroundColor: backgroundColor,
      }}
    >
      <GridLegacy
        container
        direction={'column'}
        justifyContent={'space-between'}
        height={'100%'}
        // sx={(theme) => ({ height: `calc(100% - ${theme.spacing(5)})` })}
      >
        <GridLegacy item>
          <Stack
            direction={'row'}
            alignItems={'flex-start'}
            justifyContent={'space-between'}
          >
            <Typography fontSize={14} color="text.secondary" gutterBottom>
              {title}
            </Typography>
            <Icon name={'ChevronRight'} />
          </Stack>
        </GridLegacy>

        <GridLegacy item sx={{ pt: 5 }}>
          <Typography variant="h3">{counterValue}</Typography>
        </GridLegacy>
      </GridLegacy>
    </Card>
  );
};
export default Counter;
